<template>
	<div>
		<app-step-header></app-step-header>
		<loader v-if="pageLoader"></loader>
		<router-view :options="registerOptions"/>
	</div>
</template>

<script>
	import step_header from './reg-step-header'
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	export default {
		name: 'App',
		data() {
			return {
				pageLoader: false,
				pageTxt: '',
			}
		},
		components: {
			appStepHeader : step_header
		},
		computed:{
			registerOptions(){
				return this.$store.getters[types.GET_REGISTER_OPTIONS];
			}
		},
		methods:{
			...mapActions({
				_runRegisterOption: types.RUN_REGISTER_OPTIONS
			})
		},
		created(){
			this._runRegisterOption({'globalParams' :{},'localParams' :{ "parameter" : this }})
		}

		
	}
</script>


// WEBPACK FOOTER //
// src/components/website/registerSteps/index.vue